import React, { useState, useEffect } from 'react'
import Header from '../components/Header/index'
import { useLocation, useNavigate } from 'react-router-dom'
import './TesislerList.css'
import TubitakWarningModal from '../components/TubitakWarningModal'
import axios from 'axios'
import LoadingAbsolute from '../components/Loading/LoadingAbsolute'
import EyeSvg from '../assets/icons/EyeSvg'
import InfoCircleSvg from '../assets/icons/InfoCircleSvg'
import InfoModal from '../components/InfoModal'
import { useDispatch } from 'react-redux'
import { setTesis } from '../store/tesisReducer'
import Empty from '../components/Empty/Empty'
import { closeWebView, isBridgeAvailable } from './HobiBahcesiGirisSistemi/services/nativeBridge'
import { clearPersistedSelectedGarden, persistSelectedGarden } from './HobiBahcesiGirisSistemi/services/selectedGardenStorage'

const TESIS_GORSEL_URL = 'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/tesisler/'

const uniqueTesisIds = (list) =>
  (list ?? []).reduce((acc, curr) => {
    if (!acc.includes(curr.tesis_id)) {
      acc.push(curr.tesis_id)
    }
    return acc
  }, [])

const SectionHeader = ({ title, description, count }) => (
  <div className='section-header'>
    <div className='section-header__title'>
      <span>{title}</span>
      <span className='section-header__count'>{count}</span>
    </div>
    <div className='section-header__description'>{description}</div>
  </div>
)

const TesisCard = ({ img, title, address, badge, onClick, children }) => (
  <div className={`list-item${onClick ? ' list-item--clickable' : ''}`} onClick={onClick}>
    <div className='item-image'>
      <img alt='' src={TESIS_GORSEL_URL + img} />
    </div>
    <div className='item-body'>
      <div>
        <div className='item-title'>{title}</div>
        <div className='item-adress'>{address}</div>
      </div>
      <div className='item-footer'>
        <div className='item-actions'>{children}</div>
        {badge}
      </div>
    </div>
  </div>
)

const TesislerList = (props) => {
  let location = useLocation()
  const token = location.search.slice(7)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [optionModalOpen, setOptionModalOpen] = useState(false)
  const [selectedTesisOptions, setSelectedTesisOptions] = useState(null)

  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })

  const getData = async () => {
    setLoading(true)
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/sosyal-tesisleri-sorgula`, {
        params: {
          token: JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        setLoading(false)
        if (res.data.code === 200) {
          setData(res.data.data)
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
  }

  useEffect(() => {
    clearPersistedSelectedGarden()

    if (token) {
      localStorage.setItem('token', JSON.stringify(token))
    }
    getData()
  }, [token])

  const tesisler = data?.tesisler ?? []
  const kayitliIds = uniqueTesisIds(data?.user?.kayitli_tesisler)
  const onayBekleyenlerIds = uniqueTesisIds(data?.user?.onay_bekliyen_tesisler)

  const getItem = (tesisId) => tesisler.find((tesis) => tesisId === tesis.id)

  // Harici tesisler (orn. Karatay Tenis Kortu) uyelik gerektirmez, herkese aciktir.
  // Bu yuzden "kayitli oldugunuz" listesinde degil, kendi bolumunde gosterilir.
  const acikHizmetler = tesisler.filter((tesis) => tesis.is_external)
  const uyeOlunanTesisler = tesisler.filter((tesis) => !tesis.is_external && kayitliIds.includes(tesis.id))

  const gosterilecekBolumVar = uyeOlunanTesisler.length > 0 || acikHizmetler.length > 0 || onayBekleyenlerIds.length > 0

  const handleBackButton = () => {
    if (isBridgeAvailable()) {
      closeWebView()
      return
    }

    navigate(-1)
  }

  const goToExternal = (item) => {
    const url = item?.is_required_token
      ? `${item.external_url}${item.external_url.includes('?') ? '&' : '?'}token=${token}`
      : item.external_url
    window.location.href = url
  }

  const buildSelectedTesis = (item) => ({
    ...item,
    user: data?.user?.kayitli_tesisler,
    azim: kayitliIds.includes(item.id),
  })

  const goToTesis = (item) => {
    // Hobi bahceleri (Saracoglu / Karaaslan) kendi giris sistemine yonlendirilir.
    if (item.id === 6 || item.id === 7) {
      const selectedTesisPayload = buildSelectedTesis(item)

      dispatch(setTesis(selectedTesisPayload))
      persistSelectedGarden(selectedTesisPayload)

      navigate('/hobiHome', {
        state: { selectedTesis: selectedTesisPayload },
      })
      return
    }

    navigate('/home', {
      state: { selectedTesis: buildSelectedTesis(item) },
    })
  }

  return (
    <>
      {loading ? <LoadingAbsolute formText={'Belgeleriniz yükleniyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={handleBackButton} />
        </div>

        {data && !gosterilecekBolumVar && (
          <div className='p-3'>
            <Empty text='Görüntülenebilecek bir tesis bulunmamaktadır.' />
          </div>
        )}

        {uyeOlunanTesisler.length > 0 && (
          <div className='tesis-section'>
            <SectionHeader title='Kayıtlı Tesisler' description='Başvurunuz onaylandı, bu tesisleri kullanabilirsiniz.' count={uyeOlunanTesisler.length} />
            {uyeOlunanTesisler.map((item) => (
              <TesisCard
                key={item.id}
                img={item.img}
                title={item.title}
                address={item.address}
              >
                <button
                  style={{ backgroundColor: '#56A54D' }}
                  className='ozellikBtn'
                  onClick={(e) => {
                    e.stopPropagation()
                    goToTesis(item)
                  }}
                >
                  <EyeSvg />
                  <div style={{ margin: '0 0 0 0.4rem' }}>Görüntüle</div>
                </button>
              </TesisCard>
            ))}
          </div>
        )}

        {acikHizmetler.length > 0 && (
          <div className='tesis-section'>
            <SectionHeader title='Tesisler' description='Üyelik gerekmez, doğrudan kullanabilirsiniz.' count={acikHizmetler.length} />
            {acikHizmetler.map((item) => (
              <TesisCard
                key={item.id}
                img={item.img}
                title={item.title}
                address={item.address}
              >
                <button
                  style={{ backgroundColor: '#0090FF' }}
                  className='ozellikBtn'
                  onClick={(e) => {
                    e.stopPropagation()
                    if (item.is_external && item.external_url) {
                      goToExternal(item)
                      return
                    }
                    goToTesis(item)
                  }}
                >
                  <EyeSvg />
                  <div style={{ margin: '0 0 0 0.4rem' }}>Görüntüle</div>
                </button>
              </TesisCard>
            ))}
          </div>
        )}

        {onayBekleyenlerIds.length > 0 && (
          <div className='tesis-section'>
            <SectionHeader title='Onay Bekleyen Başvurularınız' description='Başvurunuz değerlendiriliyor, henüz üye değilsiniz.' count={data?.user?.onay_bekliyen_tesisler?.length} />
            {data?.user?.onay_bekliyen_tesisler?.map((item) => (
              <TesisCard
                key={item.id}
                img={getItem(item.tesis_id)?.img}
                title={getItem(item.tesis_id)?.title}
                address={getItem(item.tesis_id)?.address}
                badge={<div className='durum-rozeti durum-rozeti--bekliyor'>Beklemede</div>}
                onClick={() => navigate('/home', { state: { selectedTesis: buildSelectedTesis(item) } })}
              >
                <button
                  style={{ backgroundColor: '#0090FF' }}
                  className='ozellikBtn'
                  onClick={(e) => {
                    e.stopPropagation()
                    setSelectedTesisOptions(item)
                    setOptionModalOpen(true)
                  }}
                >
                  <InfoCircleSvg />
                  <div style={{ margin: '0 0 0 0.4rem' }}>Başvuru Bilgisi</div>
                </button>
              </TesisCard>
            ))}
          </div>
        )}
      </div>
      <TubitakWarningModal show={warningModalOpen.active} onHide={() => setWarningModalOpen({ state: '', active: false })} state={warningModalOpen.state} message={warningModalOpen.message} />
      {selectedTesisOptions && <InfoModal show={optionModalOpen} onHide={() => setOptionModalOpen(false)} infos={selectedTesisOptions} title={'Başvuru Bilgileriniz'} />}
    </>
  )
}

export default TesislerList
